import React, { lazy, Suspense } from 'react';
import 'react-quill/dist/quill.snow.css';

const ReactQuill = lazy(() => import('react-quill'));

const DuzenlemeFormu = ({ duzenlenmisSablon, handleIcerikChange }) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
      <label htmlFor="icerik" className="app-label">İçerik</label>
      <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-3">
        <div className="h-[calc(100vh-460px)] min-h-[320px] overflow-hidden">
          <Suspense fallback={<div className="p-4 text-sm text-slate-400">Yükleniyor...</div>}>
            <ReactQuill
              id="icerik"
              value={duzenlenmisSablon.icerik}
              onChange={handleIcerikChange}
              className="h-full pb-12"
              theme="snow"
              modules={{
                toolbar: [
                  [{ 'header': [1, 2, 3, false] }],
                  ['bold', 'italic', 'underline'],
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                  ['link', 'image'],
                  ['clean']
                ],
              }}
              ref={(el) => {
                if (el) {
                  el.getEditor().root.setAttribute('data-gramm', 'false');
                }
              }}
            />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default DuzenlemeFormu;
